import { BaseComponent } from '../base.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UUID } from 'angular2-uuid';
import { Observable } from 'rxjs/Observable';
import { NgbTabChangeEvent, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {
  AbwesenheitsAntrag, AbwesenheitsAntragStunden, CustomProffixService,
  Feiertag, StundenPlan, HelpersService, UserSessionService
} from '../../services';

import {
  Login,
  Mitarbeiter,
  MitarbeiterService,
  StundenartService,
  Stundenart
} from '@proffix/restapi-angular-library';

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;

@Component({
  selector: 'app-absences-new',
  templateUrl: './absences-new.component.html',
  styleUrls: ['./absences-new.component.css']
})
export class AbsencesNewComponent extends BaseComponent implements OnInit {
  proffixLogin: Login = null;
  antragStundenart: Stundenart;
  antragStartDatum: NgbDateStruct;
  antragEndDatum: NgbDateStruct;
  antragBemerkungMitarbeiter: string;

  hoveredDate: NgbDateStruct;

  listOfStundenarten: Stundenart[];
  listOfAntragsStunden: AbwesenheitsAntragStunden[] = [];
  listOfFeiertage: Feiertag[];
  sollStundenPlan: StundenPlan;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _customProffixService: CustomProffixService,
    private _helpersService: HelpersService,
    private _userSessionService: UserSessionService,
    private _mitarbeiterService: MitarbeiterService,
    private _stundenartService: StundenartService,
    private _modalService: NgbModal,
  ) {
    super();
  }

  ngOnInit() {
    // load current PROFFIX user
    this._userSessionService.getProffixLogin().subscribe(data => {
      this.proffixLogin = data;

      // load the "Stundenarten"
      this._stundenartService.getAll({}).subscribe(stundenarten => {
        stundenarten.sort((x, y) => {
          if (x.Bezeichnung < y.Bezeichnung) {
            return -1;
          } else if (x.Bezeichnung > y.Bezeichnung) {
            return 1;
          } else {
            return 0;
          }
        });

        this.listOfStundenarten = stundenarten.filter((s) => {
          if (s.ZeitErfassen === true) {
            return false;
          } else {
            // only use "Stundenarten" that do not have a start and an end time.
            return true;
          }
        });

        // next: load the pulic holidays (Feiertage)
        this._customProffixService.getAllFeiertage({}).subscribe(feiertage => {
          this.listOfFeiertage = feiertage;

          if (this.proffixLogin.Mitarbeiter && this.proffixLogin.Mitarbeiter.Zusatzfelder.Z_Zeitmanagement_StdPlanPRO) {
            // next: try to load the "Soll-Stunden-Plan"
            this._customProffixService.getAllStundenPlaene({
              filter: 'StdPlanPRO==' + this.proffixLogin.Mitarbeiter.Zusatzfelder.Z_Zeitmanagement_StdPlanPRO
            }).subscribe(plaene => {
              this.sollStundenPlan = plaene[0];
            });
          }
        });
      });
    });
  }

  public onTabChange($event: NgbTabChangeEvent) {
    if ($event.nextId === 'tab-hours') {
      if (this.antragStundenart && this.antragStartDatum && this.antragStartDatum) {
        this.buildAntragsStunden();
      } else {
        $event.preventDefault();
      }
    }
  }

  public onDateChange(date: NgbDateStruct) {
    if (!this.antragStartDatum && !this.antragEndDatum) {
      this.antragStartDatum = date;
    } else if (this.antragStartDatum && !this.antragEndDatum && after(date, this.antragStartDatum)) {
      this.antragEndDatum = date;
    } else {
      this.antragEndDatum = null;
      this.antragStartDatum = date;
    }
  }

  public onAntragStundenRemoveClick(std: AbwesenheitsAntragStunden) {
    this.listOfAntragsStunden.splice(this.listOfAntragsStunden.indexOf(std), 1);
  }

  public onCreateAntrag(content: any) {
    if (this.validate()) {
      const antrag: AbwesenheitsAntrag = {
        Id: UUID.UUID(),
        StatusCode: 1, // pendent
        StundenartZEI: this.antragStundenart.StundenartNr,
        MitNrPRO: this.proffixLogin.Mitarbeiter.MitarbeiterNr,
        StartDatum: this.toDate(this.antragStartDatum),
        EndDatum: this.toDate(this.antragEndDatum),
        BemerkungMitarbeiter: this.antragBemerkungMitarbeiter,
        BemerkungManager: '',
      };

      // filter for days without hours (Stunden=0)
      this.listOfAntragsStunden = this.listOfAntragsStunden.filter(val => { return val.Stunden != 0 });

      // POST request for the "Abwesenheits-Antrag" (header)
      this._customProffixService.postAbwesenheitsAntraege(antrag).subscribe(() => {
        // Create the POST requests for the "Stunden" (hour records)
        for (const std of this.listOfAntragsStunden) {
          std.AbwAntragKopfId = antrag.Id;
        }

        // execute all requests in a sequence
        this.postNextAbwesenheitsAntragStunden(() => {
          this._modalService.open(content).result.then(
            () => { this._router.navigate(['absences']); },
            () => { this._router.navigate(['absences']); }
          );
        });
      });
    }
  }

  private validate(): boolean {
    let isValid = true;

    if (!this.antragBemerkungMitarbeiter) {
      // employees must comment their requests
      this.addWarningAlert('Es muss eine Bemerkung ausgefüllt werden.');

      isValid = false;
    }

    return isValid;
  }

  private postNextAbwesenheitsAntragStunden(onSuccess: () => void) {
    const nextStunde = this.listOfAntragsStunden.shift();

    // Create the POST request for the "Stunden" (hour records)
    this._customProffixService.postAbwesenheitsAntragStunden(nextStunde).subscribe(() => {
      if (this.listOfAntragsStunden.length > 0) {
        this.postNextAbwesenheitsAntragStunden(onSuccess);
      } else {
        onSuccess();
      }
    });
  }

  public filterVerwendeteStundenarten(s: Stundenart): boolean {
    return s.Zusatzfelder.Z_In_Zeitmanagement_WebApp_verwenden === true;
  }

  private buildAntragsStunden(): void {
    // empty the list of "Stunden"
    this.listOfAntragsStunden = [];

    const currentDate = this.toDate(this.antragStartDatum);
    const endDate = this.toDate(this.antragEndDatum);

    while (endDate >= currentDate) {
      const abwesenheitsAntragStunden: AbwesenheitsAntragStunden = {
        Id: UUID.UUID(),
        Datum: new Date(currentDate),
      };

      if (this.sollStundenPlan) {
        abwesenheitsAntragStunden.Stunden = this.getStundenFromSollStundenPlan(currentDate);
      } else {
        if (this.isWeekend(currentDate)) {
          abwesenheitsAntragStunden.Stunden = 0;
        } else {
          abwesenheitsAntragStunden.Stunden = this.antragStundenart.Vorgabezeit;
        }
      }

      // handle the hour reduction caused by public holidays
      const feiertag = this.findFeiertag(currentDate);

      if (feiertag && abwesenheitsAntragStunden.Stunden > 0) {
        abwesenheitsAntragStunden.Stunden = abwesenheitsAntragStunden.Stunden - feiertag.Stunden;
      }

      if (abwesenheitsAntragStunden.Stunden < 0) {
        abwesenheitsAntragStunden.Stunden = 0;
      }

      this.listOfAntragsStunden.push(abwesenheitsAntragStunden);

      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  private getStundenFromSollStundenPlan(date: Date): number {
    if (this.sollStundenPlan && date) {
      if (date.getDay() === 1) { return this.sollStundenPlan.Montag; }
      if (date.getDay() === 2) { return this.sollStundenPlan.Dienstag; }
      if (date.getDay() === 3) { return this.sollStundenPlan.Mittwoch; }
      if (date.getDay() === 4) { return this.sollStundenPlan.Donnerstag; }
      if (date.getDay() === 5) { return this.sollStundenPlan.Freitag; }
      if (date.getDay() === 6) { return this.sollStundenPlan.Samstag; }
      if (date.getDay() === 0) { return this.sollStundenPlan.Sonntag; }
    }
    return 0;
  }

  private toDate(date: NgbDateStruct) {
    return new Date(Date.UTC(date.year, date.month - 1, date.day));
  }

  private isWeekend(date: Date): boolean {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  private findFeiertag(date: Date): Feiertag {
    return this.listOfFeiertage.find((value) => {
      const feiertagDate = new Date(value.Datum);

      return feiertagDate.getFullYear() === date.getFullYear()
        && feiertagDate.getMonth() === date.getMonth()
        && feiertagDate.getDate() === date.getDate();
    });
  }

  isHovered = date => this.antragStartDatum && !this.antragEndDatum && this.hoveredDate && after(date, this.antragStartDatum) && before(date, this.hoveredDate);
  isInside = date => after(date, this.antragStartDatum) && before(date, this.antragEndDatum);
  isFrom = date => equals(date, this.antragStartDatum);
  isTo = date => equals(date, this.antragEndDatum);
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/absences-new/absences-new.component.ts